import { useState } from "react";
import { 
    Container, 
    Table, 
    TLBody, 
    TLCellHead } from "./styles";

/*
* Estructura de props: 
headers = [
    {
        title, icon, control?
    }
]
*/

const CustomTableList = ({
    headers = [],
    children,
    minWidth,
    maxHeight,
    scrollColor = "primary",
    variant = "primary"
}) => {
    const [scrollingTable, setScrollingTable] = useState(false);
    return (
        <Container className={scrollColor} maxHeight={maxHeight} onScroll={e => {
            setScrollingTable(e.target.scrollTop > 18);
        }}>
            <Table 
                className={variant}
                minWidth={minWidth}
                boxShadow={scrollingTable ? "8px 16px 20px -12px #161D1F3D" : ""}>
                <thead>
                    <tr>
                        {headers.map(({
                            title, icon, control
                        }, idx) => {
                            return (
                                <TLCellHead key={idx}>
                                    <div>
                                        {icon && icon}
                                        {title && <span key={idx}>{title}</span>}
                                        {control && control}
                                    </div>
                                </TLCellHead>
                            );
                        })}
                        <th></th>
                    </tr>
                </thead>
                <TLBody>
                    {children}
                </TLBody>
            </Table>
        </Container>
    );
}

export default CustomTableList;